import { createBlock as r, openBlock as o, Transition as s, withCtx as n, renderSlot as i } from "vue";
import { _ as p } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  props: {
    appear: {
      type: Boolean
    }
  },
  emits: ["after-enter"]
};
function l(e, t, a, f, d, m) {
  return o(), r(s, {
    appear: a.appear,
    "enter-active-class": "duration-300 ease-out",
    "enter-from-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-active-class": "transition-opacity duration-200 ease-in",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0",
    onAfterEnter: t[0] || (t[0] = (u) => e.$emit("after-enter"))
  }, {
    default: n(() => [
      i(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["appear"]);
}
const _ = /* @__PURE__ */ p(c, [["render", l]]);
export {
  _ as default
};
